import { jsx as ___EmotionJSX } from "@emotion/core";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { ClassNames } from '@emotion/core';
import { Popover, MenuList } from '@material-ui/core';
import Downshift from 'downshift';
import style from "./Menu.style";

const getAnchorOrigin = ({
  anchorOrigin,
  above,
  alignRight
}) => _objectSpread({
  vertical: above ? 'top' : 'bottom',
  horizontal: alignRight ? 'right' : 'left'
}, anchorOrigin);

const getTransformOrigin = ({
  transformOrigin,
  above,
  alignRight
}) => _objectSpread({
  vertical: above ? 'bottom' : 'top',
  horizontal: alignRight ? 'right' : 'left'
}, transformOrigin);

const getApplicableClass = css => ({
  above,
  elevated
}) => css`
  ${style.paper.base};
  ${above ? style.paper.above : style.paper.under};
  ${elevated ? style.paper.elevated : style.paper.unelevated};
`;

export default class Menu extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      anchorElement: null,
      highlightedIndex: 0
    };
    this.buttonContainer = null;
    this.handleClose = this.handleClose.bind(this);
    this.handleTargetClick = this.handleTargetClick.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleDownshiftStateChange = this.handleDownshiftStateChange.bind(this);
    this.downshift = React.createRef();
  }

  handleClose(e) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({
      anchorElement: null
    });
  }

  handleTargetClick(event) {
    event.preventDefault();
    event.stopPropagation();
    this.setState({
      anchorElement: event.currentTarget
    });
  }

  handleSelect(item) {
    const {
      onSelect
    } = this.props;
    let shouldClose = true;

    const close = () => {
      this.setState({
        anchorElement: null,
        highlightedIndex: 0
      });
    };

    const preventClose = () => {
      shouldClose = false;
    };

    onSelect({
      item,
      preventClose
    });

    if (shouldClose) {
      close();
    }
  }

  handleDownshiftStateChange(changes) {
    const hasHighlightedIndex = typeof changes.highlightedIndex !== 'undefined';
    const closing = changes.isOpen === false;

    if (hasHighlightedIndex && !closing) {
      this.setState({
        highlightedIndex: changes.highlightedIndex
      });
    }
  }

  render() {
    const _this$props = this.props,
          {
      above,
      alignRight,
      anchorOrigin,
      className,
      renderTarget,
      renderChildren,
      elevated,
      classes: {
        paper: paperClass,
        menu: menuClass
      },
      testID,
      ariaLabelledby,
      transformOrigin,
      menuListComponent,
      menuListAttributes
    } = _this$props,
          otherProps = _objectWithoutProperties(_this$props, ["above", "alignRight", "anchorOrigin", "className", "renderTarget", "renderChildren", "elevated", "classes", "testID", "ariaLabelledby", "transformOrigin", "menuListComponent", "menuListAttributes"]);

    const {
      highlightedIndex
    } = this.state;
    const originProps = {
      above,
      alignRight,
      anchorOrigin,
      transformOrigin
    };
    const isOpen = !!this.state.anchorElement; // Note: Using emotion `classNames` module to pass className prop to
    // Paper element via `PaperProps`

    return ___EmotionJSX(Downshift, {
      id: `${testID}-downshift`,
      ref: this.downshift,
      isOpen: isOpen,
      highlightedIndex: highlightedIndex,
      onSelect: this.handleSelect,
      defaultHighlightedIndex: 0,
      onStateChange: this.handleDownshiftStateChange,
      labelId: ariaLabelledby
    }, ({
      getInputProps,
      getItemProps
    }) => ___EmotionJSX("div", {
      className: className,
      id: testID,
      role: undefined,
      "aria-expanded": undefined,
      "aria-haspopup": undefined
    }, renderTarget({
      handleTargetClick: this.handleTargetClick,
      isOpen
    }), ___EmotionJSX(ClassNames, null, ({
      css,
      cx
    }) => ___EmotionJSX(Popover, _extends({
      PaperProps: {
        elevation: 0,
        className: cx(getApplicableClass(css)({
          above,
          elevated
        }), paperClass)
      },
      open: isOpen,
      anchorEl: this.state.anchorElement,
      onClose: this.handleClose
    }, otherProps, {
      anchorOrigin: getAnchorOrigin(originProps),
      transformOrigin: getTransformOrigin(originProps)
    }, getInputProps()), ___EmotionJSX(MenuList, _extends({
      disablePadding: true,
      component: menuListComponent,
      className: menuClass
    }, menuListAttributes), renderChildren({
      getItemProps,
      highlightedIndex
    }))))));
  }

}
Menu.propTypes = {
  /**
   * Function to render the children of the menu element.
   *
   * Menu uses Downshift for accessible and keyboard navigable
   * contents. The renderChildren function will be called with an
   * object containing:
   *
   * * getItemProps: call and apply all props on every selectable
   * item in the menu. It takes an object with an `item` key. This
   * will be used in the `onSelect` callback prop in order to identify
   * the selected item.
   * * highlightedIndex: index of the selected item in the menu. Should
   * be used to apply special styling.
  */
  renderChildren: PropTypes.func,

  /**
   * If true, menu will display above target
   */
  above: PropTypes.bool,

  /**
   * If true, menu will be align right with the right side of target
   */
  alignRight: PropTypes.bool,

  /**
   * If true, increases the box-shadow so that the menu looks higher
   */
  elevated: PropTypes.bool,

  /**
   * Function to render component to use as an anchor. It receives
   * an object as parameter with the following fields:
   * * handleTargetClick: handler to be passed to the target's `onClick`.
   */
  renderTarget: PropTypes.func.isRequired,

  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   */
  transformOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['left', 'center', 'right'])]).isRequired,
    vertical: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['top', 'center', 'bottom'])]).isRequired
  }),

  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   */
  anchorOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['left', 'center', 'right'])]).isRequired,
    vertical: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['top', 'center', 'bottom'])]).isRequired
  }),

  /**
   * This is the position that may be used
   * to set the position of the popover.
   * The coordinates are relative to
   * the application's client area.
   */
  anchorPosition: PropTypes.shape({
    left: PropTypes.number.isRequired,
    top: PropTypes.number.isRequired
  }),

  /*
   * This determines which anchor prop to refer to to set
   * the position of the popover.
   */
  anchorReference: PropTypes.oneOf(['anchorEl', 'anchorPosition', 'none']),

  /*
   * A string className that will be applied to the root element
   */
  className: PropTypes.string,

  /*
   * Classes for applying styles to sub-elements
   */
  classes: PropTypes.shape({
    paper: PropTypes.string,
    menu: PropTypes.string
  }),
  testID: PropTypes.string,
  ariaLabelledby: PropTypes.string,
  menuListComponent: PropTypes.string,

  /*
   * The object with menuList attributes
   */
  menuListAttributes: PropTypes.shape(),

  /**
   * Called when an item in the menu has been selected. It receives
   * a params object:
   * * item: item selected
   * * preventClose: if called, the menu is not closed after the handler
   * finishes execution.
   */
  onSelect: PropTypes.func
};
Menu.defaultProps = {
  renderChildren: () => {},
  above: false,
  alignRight: false,
  anchorOrigin: {
    horizontal: 'left',
    vertical: 'bottom'
  },
  anchorPosition: {
    top: 0,
    left: 0
  },
  elevated: true,
  transformOrigin: {
    horizontal: 'left',
    vertical: 'top'
  },
  anchorReference: 'anchorEl',
  className: '',
  classes: {},
  testID: undefined,
  ariaLabelledby: '',
  onSelect: () => {},
  menuListComponent: 'div',
  menuListAttributes: {}
};